// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'

export class Section1 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section one'>
       <div className="wrapper">
        <h2 style={{marginTop: '0'}}>Une espèce animale fortement répandue à travers le pays</h2>
        <div className='two-column'>
            <div className={'column left'} key={'left'}>
              <div className='txt'>
                On connaît le nombre exact de chiens vivant en Suisse. L'enregistrement de ces animaux est en effet obligatoire. Fin février, la base de données comptait 556’543 chiens, soit près de 13% de plus qu'il y a sept ans. Leur nombre a donc augmenté plus fortement que la population suisse. On compte aujourd'hui un compagnon à quatre pattes pour 16 habitants et habitantes.
              </div>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/A41Zh/1/' + '?dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>
            </div>

            <div className={'column right'} key={'right'}>
              <div className='txt'>
                La pandémie a encore accentué cette tendance. En 2020 et 2021, le nombre de chiens a augmenté bien plus fortement que les années précédentes, car de nombreuses personnes se sont senties seules en raison des restrictions imposées par le coronavirus. Elles ont manifestement voulu combler ce vide avec un animal de compagnie. En moyenne 15’000 chiens ont été adoptés par an durant cette période. Normalement, la moyenne annuelle se situe aux environs de 6000.
              </div>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/dgxJq/1/' + '?dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>

              <div className='txt'>
                <p>
                  L'année dernière, l’effet coronavirus s'est poursuivi, tout en s’atténuant légèrement. Désormais, la tendance semble pourtant s’inverser à nouveau: en décembre 2022 et janvier 2023, pour la première fois depuis le début de la pandémie, le nombre de chiens enregistrés a diminué durant deux mois consécutifs.
                </p>
              </div>
            </div>
        </div>
      </div>
    </div>
  }
}
